import {
  ExternalConnectionsTypes,
  FirestoreCollections,
  ID,
} from '@griply/types';

import { FirestoreInstance, WhereFilterOp } from '../types/firestore';

export type GetExternalConnectionsQueryOptions<
  TCollection = unknown,
  TQuery = unknown,
  TConstraint = unknown,
  TDb = FirestoreInstance,
> = {
  db: TDb;
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollection;
  query: (ref: TCollection, ...constraints: TConstraint[]) => TQuery;
  where: (field: string, op: WhereFilterOp, value: unknown) => TConstraint;
  userId: ID;
};

export const getExternalConnectionsQuery = <
  TCollection,
  TQuery,
  TConstraint,
  TDb = FirestoreInstance,
>(
  options: GetExternalConnectionsQueryOptions<
    TCollection,
    TQuery,
    TConstraint,
    TDb
  >,
): TQuery => {
  const { db, collection, query, where, userId } = options;

  const constraints: TConstraint[] = [
    where('roles.all', 'array-contains', userId),
    where('type', '==', ExternalConnectionsTypes.Calendar),
  ];

  return query(
    collection(db, FirestoreCollections.ExternalConnections),
    ...constraints,
  );
};
